import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import NewsList from './NewsList';
import './News.css';

// Мобильный вид новостей: отдельная страница без модалок
const NewsPage = () => {
  const { t } = useLanguage();

  return (
    <div className="news-page">
      <div className="news-page-header">
        <h2>{t('news.title')}</h2>
        <p className="news-page-subtitle">{t('news.subtitle')}</p>
      </div>
      <NewsList />
    </div>
  );
};

export default NewsPage;
